import type { BaseSyncableEntity } from '@/types/syncableEntity'

export interface Workspace extends BaseSyncableEntity {
  name: string
  description?: string | null
  isPublic: boolean
  mapPosition?: {
    center: [number, number] | null
    zoom: number | null
  }
  // User role and permission fields from API.
  userRole?: string | null
  canEdit?: boolean | null
  canManage?: boolean | null
  canView?: boolean | null
  isBookmarked?: boolean
  systemKey?: string | null
  isSystem?: boolean
  // Owner display names from API (for permission hints)
  ownerNames?: string[] | null
  // Cover photo
  coverPhotoClientId?: string | null
  // Soft deletion fields
  markedForDeletion: boolean
  deletionScheduledAt: string | null
}

// Workspace member interfaces for role management
export interface WorkspaceMember {
  userId: number
  name: string
  email: string
  roleDisplay: string
  role: number
  createdAt: string
}

export interface WorkspaceInvitation {
  id: number
  email: string
  roleDisplay: string
  invitedByName: string
  invitedByEmail: string
  isExpired: boolean
  token: string
  createdAt: string
  expiresAt: string
  isAccepted: boolean
  acceptedAt: string | null
}

// Role constants
export const WorkspaceRole = {
  OWNER: 0,
  COLLABORATOR: 1,
  VIEWER: 2,
} as const

export type WorkspaceRoleType = (typeof WorkspaceRole)[keyof typeof WorkspaceRole]

// Role display names
export const WorkspaceRoleDisplayNames = {
  [WorkspaceRole.OWNER]: 'Owner',
  [WorkspaceRole.COLLABORATOR]: 'Collaborator',
  [WorkspaceRole.VIEWER]: 'Viewer',
} as const

export const AssignableWorkspaceRoles = [WorkspaceRole.COLLABORATOR, WorkspaceRole.VIEWER] as const
